import Vue from 'vue';
import { getGoogleTagManager, setProduct } from '@/utils';
import VueGtm from '@gtm-support/vue2-gtm';
import Router from '@/router';

const state = {
    analyticsEnabled: false,
};

const getters = {
    getAnalyticsEnabled: (state) => state.analyticsEnabled,
};

const mutations = {
    SET_ANALYTICS_ENABLED(state, payload) {
        state.analyticsEnabled = payload;
    },
};

const actions = {
    async useAnalytics({ commit }) {
        try {
            commit('SET_ANALYTICS_ENABLED', true);
            if (getGoogleTagManager(setProduct(window.location.hostname))) {
                Vue.use(VueGtm, {
                    id: getGoogleTagManager(setProduct(window.location.hostname)),
                    vueRouter: Router,
                });
            }
        }
        catch (e) {
            console.warn('Google Tag Manager instance not initiated');
            console.error(e);
            commit('SET_ANALYTICS_ENABLED', false);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
